import { MEDIA_URL } from '@/constants/env';

const images = [
  {
    image: MEDIA_URL.concat('/powerplant/1.jpg'),
  },
  {
    image: MEDIA_URL.concat('/powerplant/2.jpg'),
  },
  {
    image: MEDIA_URL.concat('/powerplant/3.jpg'),
  },
  {
    image: MEDIA_URL.concat('/powerplant/4.jpg'),
  },
  {
    image: MEDIA_URL.concat('/powerplant/5.jpg'),
  },
  {
    image: MEDIA_URL.concat('/powerplant/6.jpg'),
  },
  {
    image: MEDIA_URL.concat('/powerplant/7.jpg'),
  },
  {
    image: MEDIA_URL.concat('/powerplant/8.jpg'),
  },
];

export const projects = [
  {
    image: MEDIA_URL.concat('/construction-projects/03aff2a5-46b3-4ada-8123-6cf976c3c2ef.jpg'),
    companies: ['construction'],
  },
  {
    image: MEDIA_URL.concat('/construction-projects/3d0db60a-77ae-4cc7-9182-87b8021b1c9d.jpg'),
    companies: ['construction'],
  },
  {
    image: MEDIA_URL.concat('/construction-projects/7b8faaec-8ec6-4e1b-9710-5196bfd9a98c.jpg'),
    companies: ['construction'],
  },
  {
    image: MEDIA_URL.concat('/construction-projects/8a18e17e-f8e6-4629-89d4-5691b7b5dbad.jpg'),
    companies: ['construction'],
  },
  {
    image: MEDIA_URL.concat('/construction-projects/8c59be45-a43f-4a5f-ada6-79ea78296ba3.jpg'),
    companies: ['construction'],
  },
  {
    image: MEDIA_URL.concat('/construction-projects/221f0846-fa13-4431-a8d0-4d005f3877e7.jpg'),
    companies: ['construction'],
  },
  {
    image: MEDIA_URL.concat('/construction-projects/3242a1ce-7c40-4342-bd3d-8e4a004c715c.jpg'),
    companies: ['construction'],
  },
  {
    image: MEDIA_URL.concat('/construction-projects/3335c254-6613-4bb7-b4e4-e1ad8b11a41b.jpg'),
    companies: ['construction'],
  },
  {
    image: MEDIA_URL.concat('/construction-projects/21007b52-f263-4f48-ae05-47b395b31027.jpg'),
    companies: ['construction'],
  },
  {
    image: MEDIA_URL.concat('/construction-projects/35017645-5f7c-436a-bd12-80b6f6fa3261.jpg'),
    companies: ['construction'],
  },
  {
    image: MEDIA_URL.concat('/construction-projects/a87fc4b3-67a4-4d71-85c6-9c811f8729be.jpg'),
    companies: ['construction'],
  },

  // {
  //   image: MEDIA_URL.concat('/projects/projects2.png'),
  //   location: 'SPCS Powerplant',
  //   title: '1inch Steam line',
  //   slug: '1inch-steam-line',
  //   companies: ['construction'],
  //   images: images,
  // },
  // {
  //   image: MEDIA_URL.concat('/projects/projects6.png'),
  //   location: 'Josi Plant Staatsolie',
  //   title: 'Waterleg & Slugequalizer',
  //   slug: 'waterleg-slugequalizer',
  //   companies: ['construction'],
  //   images: images,
  // },
  // {
  //   image: MEDIA_URL.concat('/projects/projects5.png'),
  //   location: 'Staatsolie Power Company Suriname NV Tankfarm',
  //   title: 'Platforms & Stairways',
  //   slug: 'platforms-stairways',
  //   companies: ['construction'],
  //   images: images,
  // },
  // {
  //   image: MEDIA_URL.concat('/projects/projects3.png'),
  //   location: 'Surinaamse Brouwerij - Heineken',
  //   title: 'New Brewery',
  //   slug: 'new-brewery',
  //   companies: ['construction'],
  //   images: images,
  // },
  // {
  //   image: MEDIA_URL.concat('/projects/projects10.png'),
  //   location: 'Staatsolie Power Company Suriname N.V.',
  //   title: 'Air Dryer Unit',
  //   slug: 'air-dryer-unit',
  //   companies: ['construction'],
  //   images: images,
  // },
  // {
  //   image: MEDIA_URL.concat('/projects/projects9.png'),
  //   location: 'Staatsolie TLF',
  //   title: 'Pipe Spools Flowmeter & Sampling Valve',
  //   slug: 'pipe-spools-flowmeter-sampling-valve',
  //   companies: ['construction'],
  //   images: images,
  // },
  // {
  //   image: MEDIA_URL.concat('/projects/projects11.png'),
  //   location: 'SOL Suriname N.V.',
  //   title: 'Tank Demolition Project',
  //   slug: 'tank-demolition-project',
  //   companies: ['construction'],
  //   images: images,
  // },
  // {
  //   image: MEDIA_URL.concat('/projects/projects12.png'),
  //   location: 'Staatsolie Upstream Project',
  //   title: 'Pig Launcher System',
  //   slug: 'pig-launcher-system',
  //   companies: ['construction'],
  //   images: images,
  // },

  {
    image: MEDIA_URL.concat('/projects/projects1.png'),
    location: 'Jossiekreek Plant',
    title: 'Upgrade Box Seperator',
    slug: 'upgrade-box-seperator',
    companies: ['engineering'],
    images: images,
  },
  {
    image: MEDIA_URL.concat('/projects/projects2.png'),
    location: 'SPCS Powerplant',
    title: '1inch Steam line',
    slug: '1inch-steam-line',
    companies: ['engineering'],
    images: images,
  },
  {
    image: MEDIA_URL.concat('/projects/projects3.png'),
    location: 'Surinaamse Brouwerij - Heineken',
    title: 'New Brewery',
    slug: 'new-brewery',
    companies: ['engineering'],
    images: images,
  },
  {
    image: MEDIA_URL.concat('/projects/projects4.png'),
    location: 'IAMGOLD Rosebel Goldmines',
    title: 'Led Lighting',
    slug: 'led-lighting',
    companies: ['engineering'],
    images: images,
  },
  {
    image: MEDIA_URL.concat('/projects/projects5.png'),
    location: 'Staatsolie Power Company Suriname NV Tankfarm',
    title: 'Platforms & Stairways',
    slug: 'platforms-stairways',
    companies: ['engineering'],
    images: images,
  },
  {
    image: MEDIA_URL.concat('/projects/projects6.png'),
    location: 'Josi Plant Staatsolie',
    title: 'Waterleg & Slugequalizer',
    slug: 'waterleg-slugequalizer',
    companies: ['engineering'],
    images: images,
  },
  {
    image: MEDIA_URL.concat('/projects/projects7.png'),
    location: 'Staatsolie Power Company Suriname N.V.',
    title: 'Air Dryer Unit',
    slug: 'air-dryer-unit',
    companies: ['engineering'],
    images: images,
  },
  {
    image: MEDIA_URL.concat('/projects/projects8.png'),
    location: 'SOL Suriname N.V.',
    title: 'Tank Demolition Project',
    slug: 'tank-demolition-project',
    companies: ['engineering'],
    images: images,
  },
  {
    image: MEDIA_URL.concat('/projects/projects9.png'),
    location: 'Staatsolie TLF',
    title: 'Pipe Spools Flowmeter & Sampling Valve',
    slug: 'pipe-spools-flowmeter-sampling-valve',
    companies: ['engineering'],
    images: images,
  },
  {
    image: MEDIA_URL.concat('/projects/projects7.png'),
    location: 'Staatsolie TA58 Treatment Plant',
    title: 'Lighting Tower',
    slug: 'lighting-tower',
    companies: ['engineering'],
    images: images,
  },
  {
    image: MEDIA_URL.concat('/projects/projects8.png'),
    location: 'Staatsolie Josi Treatment Plant',
    title: 'Annunciation Panel',
    slug: 'annunciation-panel',
    companies: ['engineering'],
    images: images,
  },
  {
    image: MEDIA_URL.concat('/projects/projects12.png'),
    location: 'Staatsolie Upstream Project',
    title: 'Pig Launcher System',
    slug: 'pig-launcher-system',
    companies: ['engineering'],
    images: images,
  },

  {
    image: MEDIA_URL.concat('/projects/projects1.png'),
    location: 'Jossiekreek Plant',
    title: 'Upgrade Box Seperator',
    slug: 'upgrade-box-seperator',
    companies: ['manpower'],
    images: images,
  },
  {
    image: MEDIA_URL.concat('/projects/projects2.png'),
    location: 'SPCS Powerplant',
    title: '1inch Steam line',
    slug: '1inch-steam-line',
    companies: ['manpower'],
    images: images,
  },
  {
    image: MEDIA_URL.concat('/projects/projects3.png'),
    location: 'Surinaamse Brouwerij - Heineken',
    title: 'New Brewery',
    slug: 'new-brewery',
    companies: ['manpower'],
    images: images,
  },
  {
    image: MEDIA_URL.concat('/projects/projects4.png'),
    location: 'IAMGOLD Rosebel Goldmines',
    title: 'Led Lighting',
    slug: 'led-lighting',
    companies: ['manpower'],
    images: images,
  },
  {
    image: MEDIA_URL.concat('/projects/projects5.png'),
    location: 'Staatsolie Power Company Suriname NV Tankfarm',
    title: 'Platforms & Stairways',
    slug: 'platforms-stairways',
    companies: ['manpower'],
    images: images,
  },
  {
    image: MEDIA_URL.concat('/projects/projects6.png'),
    location: 'Josi Plant Staatsolie',
    title: 'Waterleg & Slugequalizer',
    slug: 'waterleg-slugequalizer',
    companies: ['manpower'],
    images: images,
  },
  {
    image: MEDIA_URL.concat('/projects/projects7.png'),
    location: 'Staatsolie Power Company Suriname N.V.',
    title: 'Air Dryer Unit',
    slug: 'air-dryer-unit',
    companies: ['manpower'],
    images: images,
  },
  {
    image: MEDIA_URL.concat('/projects/projects11.png'),
    location: 'SOL Suriname N.V.',
    title: 'Tank Demolition Project',
    slug: 'tank-demolition-project',
    companies: ['manpower'],
    images: images,
  },
  {
    image: MEDIA_URL.concat('/projects/projects9.png'),
    location: 'Staatsolie TLF',
    title: 'Pipe Spools Flowmeter & Sampling Valve',
    slug: 'pipe-spools-flowmeter-sampling-valve',
    companies: ['manpower'],
    images: images,
  },
  {
    image: MEDIA_URL.concat('/projects/projects10.png'),
    location: 'Staatsolie TA58 Treatment Plant',
    title: 'Lighting Tower',
    slug: 'lighting-tower',
    companies: ['manpower'],
    images: images,
  },
  {
    image: MEDIA_URL.concat('/projects/projects8.png'),
    location: 'Staatsolie Josi Treatment Plant',
    title: 'Annunciation Panel',
    slug: 'annunciation-panel',
    companies: ['manpower'],
    images: images,
  },
  {
    image: MEDIA_URL.concat('/projects/projects12.png'),
    location: 'Staatsolie Upstream Project',
    title: 'Pig Launcher System',
    slug: 'pig-launcher-system',
    companies: ['manpower'],
    images: images,
  },
];
